// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3La7Z","field":"styles_field__PootJ","fieldCol":"styles_fieldCol__qco72","diffCol":"styles_diffCol__3SlOt","diff":"styles_diff__3l1eu"};